import React, { useEffect } from "react";
import { useAppContext } from "../../../../Context/AppContext/AppContext";
import { Cart } from "../../../../Service/cart.service";
import { Button } from "antd";
import AddonCard from "./AddonCard";
import { useLoader } from "../../../../Context/LoaderContext";
import { Subscription } from "../../../../Entities/Subscription";
import { Plan } from "../../../../Entities/Plan";
import { StepKey } from "../../types";
import "./AddonListing.scss";

interface AddonListingProps {
  userCart: Cart;
  handleStepChange: (step: StepKey) => void;
  activePlan: Plan | null;
  currentSubscription: Subscription | null;
  mode: "upgrade" | "addon_only" | "renew";
  selectedAddonId: string | null;
}

const AddonListing: React.FC<AddonListingProps> = ({
  userCart,
  handleStepChange,
  activePlan,
  currentSubscription,
  mode,
  selectedAddonId,
}) => {
  const { setLoading, setLoadingMessage } = useLoader();
  const { addons, currentRegion } = useAppContext();

  const userCurrencyCode = currentRegion === "IND" ? "INR" : "USD";
  const userCurrencySymbol = currentRegion === "IND" ? "₹" : "$";

  let filteredAddons = addons;
  if (mode === "addon_only" && selectedAddonId) {
    filteredAddons = addons.filter((addon) => addon._id === selectedAddonId);
  }

  useEffect(() => {
    if (addons.length > 0) {
      setLoading(false);
      setLoadingMessage(null);
    } else {
      setLoading(true);
      setLoadingMessage("Loading addon plans...");
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addons]);

  const getButtonText = () => {
    if (mode === "addon_only") {
      return "Proceed to checkout";
    } else if (userCart.addons.length > 0) {
      return "Continue With Addons";
    } else {
      return "Continue Without Addons";
    }
  };

  return (
    <section className="addon-listing-container">
      {mode !== "addon_only" && (
        <div style={{ textAlign: "center" }}>
          <h1
            style={{
              fontSize: "28px",
              marginBottom: "10px",
              fontWeight: "500",
            }}
          >
            Choose <span style={{ fontWeight: "600" }}>add-ons</span>
          </h1>
          <p
            style={{
              fontSize: "14px",
              color: "#666",
              maxWidth: "500px",
              margin: "0 auto",
            }}
          >
            Choose add-ons along with your plan.
          </p>
        </div>
      )}

      <div className="addon-listing-grid">
        {filteredAddons.map((addon) => (
          <AddonCard
            key={addon._id}
            addon={addon}
            userCart={userCart}
            userCurrencyCode={userCurrencyCode}
            userCurrencySymbol={userCurrencySymbol}
            activePlan={activePlan}
            mode={mode}
          />
        ))}
      </div>

      <Button
        type="primary"
        onClick={() => handleStepChange("payment")}
        disabled={mode === "addon_only" && userCart.addons.length === 0}
      >
        {getButtonText()}
      </Button>
    </section>
  );
};

export default AddonListing;
